import { fileApi } from "@/getinfo-api/index";

export interface DiskApiListParams {
  ids?: Array<string>;
  ownerIds?: Array<string>;
  usersIds?: Array<string>;
  readUsersIds?: Array<string>;
  writeUsersIds?: Array<string>;
  title?: string;
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: DiskApiListParams, options?: any) => {
  return fileApi.DiskApi.list(
    params.ids,
    params.ownerIds,
    params.usersIds,
    params.readUsersIds,
    params.writeUsersIds,
    params.title,
    params.offset,
    params.limit,
    options
  );
};
